import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export const GLN_VALIDATION_ERRORS = {
  INVALID_CHECKSUM: 'invalidChecksum',
};

export function glnChecksumValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value || value.length !== 13) {
      // Durch pattern und required-Validator abgedeckt
      return null;
    }

    return checkGlnChecksum(value) ? null : {[GLN_VALIDATION_ERRORS.INVALID_CHECKSUM]: true};
  };
}

function checkGlnChecksum(value: string): boolean {
  const weight = 3;
  let sum = 0;
  const length = value.length;
  const checksumDigit = parseInt(value[length - 1], 10);

  for (let i = length - 2; i >= 0; i--) {
    let digit = parseInt(value[i], 10);
    if (i % 2 !== 0) {
      digit *= weight;
    }
    sum += digit;
  }

  return (10 - (sum % 10)) % 10 === checksumDigit;
}
